'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from 'next/image';
import Link from 'next/link';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function FirstBlog({ blog }: { blog: Blog }) {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'custom-container',
        'relative flex h-[500px] flex-col items-start justify-between overflow-hidden rounded-[20px] p-3 sm:p-4 lg:p-6',
      )}
    >
      <span className="z-[2] flex h-8 items-center justify-center rounded-full bg-primary px-4 text-xs font-medium text-white sm:h-[34px] sm:text-sm">
        Najnovší článok
      </span>
      <div className="relative z-10 flex flex-col items-start justify-start gap-6 sm:gap-8">
        <Heading
          title={blog.name}
          className={{ title: 'text-white', container: 'w-full max-w-[656px]' }}
        />
        <Button asChild variant={'white'}>
          <Link href={blog?.slug}>{t('text792')}</Link>
        </Button>
      </div>
      <div className={cn('absolute inset-0 z-[1] h-full w-full', 'ea-first-blog__image-overlay')} />
      <Image
        src={blog?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(blog?.image, blog?.name)}
        fill
        className="absolute inset-0 z-0 h-full w-full object-cover object-center"
      />
    </div>
  );
}
